export function useHaptic() {
  const haptic = window.Telegram?.WebApp?.HapticFeedback;

  return {
    success: () => haptic?.notificationOccurred('success'),
    error: () => haptic?.notificationOccurred('error'),
    tap: () => haptic?.impactOccurred('light'),
    warning: () => haptic?.notificationOccurred('warning'),
  };
}
